<app-si-dialog header="Add to List" [isLoading]="isLoading" modalFooterClasses="si-dialog__footer--centered">
	<ng-template appDialogBody>
		<div class="p-6">
			<mat-radio-group [(ngModel)]="selectedType" [disabled]="isLoading">
				<ng-container *ngIf="data?.type === 'Contacts'">
					<div  class="flex flex-wrap -mx-2 mb-2 ml-2" *ngIf="data.isInboxintel">Contacts: {{this.data.records.length}}</div>
					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full mb-4 px-2">
							<mat-radio-button
									value="existingContactList"
									name="addToListSelectedType"
              ><span>Add to existing contact list:</span></mat-radio-button>
						</div>
						<div class="w-full md:flex-none md:w-full mb-4 px-2" *ngIf="selectedType === 'existingContactList'">
							<app-select-load-more
								label="Select from list"
								placeholder="Select contact from list"
								labelKey="name"
								valueKey="id"
								[store]="contactListStore"
								[showClear]="false"
								(valueChangeEvent)="onContactListChanged($event)"
							></app-select-load-more>
						</div>
					</div>

					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full mb-4 px-2">
							<mat-radio-button
									value="newContactList"
									name="addToListSelectedType"
									(change)="reset()"
              ><span>Create new contact list:</span></mat-radio-button>
						</div>
						<div class="w-full md:flex-none md:w-full mt-4 px-2" *ngIf="selectedType === 'newContactList'">
							<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="mb-2 w-full">
								<mat-label>Name</mat-label>
								<input matInput type="text" placeholder="Enter name" [(ngModel)]="newContactListName"
									   autocomplete="off" maxlength="250" />
							</mat-form-field>
						</div>
					</div>

					<div *ngIf="selectedType === 'newContactList'" class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full px-2">
							<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="mb-2 w-full">
								<mat-label>Availability</mat-label>
								<mat-select [(ngModel)]="isPublicContactList" placeholder="Select availability" #siSelectRef="matSelect">
									<mat-option [value]="false">Private</mat-option>
									<mat-option [value]="true">Team</mat-option>
								</mat-select>
								<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
							</mat-form-field>
						</div>
                        <div class="w-full md:flex-none md:w-full px-2">
                            <app-multi-selector-form-field
                                showChipsList="true"
                                [items]="tagList$ | async"
                                bindLabel="name"
                                bindValue="id"
                                label="Tags"
                                placeholder="Tags"
                                [(ngModel)]="tagsContactList"
                                name="tagsContactList"
                                [isLoading]="(isCreateTagLoading$ | async) || (getTagIsLoading$ | async)"
                                ngDefaultControl
                                listElementTooltipIfTruncated="true"
                            >
                                <ng-template #preOption let-value="inputValue">
                                    <span><a class="cp-dark-link" (click)="createTag(value)">{{value}} (Create New)</a></span>
                                </ng-template>
                            </app-multi-selector-form-field>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="data?.type==='Companies'">
					<div  class="flex flex-wrap -mx-2 mb-2 ml-2" *ngIf="data.isInboxintel">Companies: {{this.data.records.length}}</div>
					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full mb-4 px-2">
							<mat-radio-button
									value="existingCompanyList"
									name="addToListSelectedType"
									(change)="reset()"
              ><span>Add to existing company list:</span></mat-radio-button>
						</div>
						<div class="w-full md:flex-none md:w-full mb-4 px-2" *ngIf="selectedType === 'existingCompanyList'">
							<app-select-load-more
								label="Select from list"
								placeholder="Select company from list"
								labelKey="name"
								valueKey="id"
								[store]="companyListStore"
								[showClear]="false"
								(valueChangeEvent)="onCompanyListChanged($event)"
							></app-select-load-more>
						</div>
					</div>

					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full mb-4 px-2">
							<mat-radio-button
									value="newCompanyList"
									name="addToListSelectedType"
									ngDefaultControl
									[(ngModel)]="selectedType"
              ><span>Create new company list:</span></mat-radio-button>
						</div>
						<div class="w-full md:flex-none md:w-full mt-4 px-2" *ngIf="selectedType === 'newCompanyList'">
							<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="mb-2 w-full">
								<mat-label>Name</mat-label>
								<input matInput type="text" placeholder="Enter name" [(ngModel)]="newCompanyListName"
									   autocomplete="off" maxlength="250" />
							</mat-form-field>
						</div>
					</div>

					<div *ngIf="selectedType === 'newCompanyList'" class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full px-2">
							<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="mb-2 w-full">
								<mat-label>Availability</mat-label>
								<mat-select [(ngModel)]="isPublicCompanyList" placeholder="Select availability" #siSelectRef2="matSelect">
									<mat-option [value]="false">Private</mat-option>
									<mat-option [value]="true">Team</mat-option>
								</mat-select>
								<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
							</mat-form-field>
						</div>
						<div class="w-full md:flex-none md:w-full px-2">
                            <app-multi-selector-form-field
                                [showChipsList]="true"
                                [items]="tagList$ | async"
                                bindLabel="name"
                                bindValue="id"
                                label="Tags"
                                placeholder="Tags"
                                [(ngModel)]="tagsCompanyList"
                                name="tagsCompanyList"
                                [isLoading]="(isCreateTagLoading$ | async)"
                                ngDefaultControl
                                [listElementTooltipIfTruncated]="true"
                            >
                                <ng-template #preOption let-value="inputValue">
                                    <span><a class="cp-dark-link" (click)="createTag(value)">{{value}} (Create New)</a></span>
                                </ng-template>
                            </app-multi-selector-form-field>
						</div>
					</div>
				</ng-container>

				<ng-container *ngIf="accountAttributesEnum.AUTOREVEAL | hasAccess">
					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full mb-4 px-2">
							<mat-radio-button
									value="suppressionList"
									name="addToListSelectedType"
									ngDefaultControl
									[(ngModel)]="selectedType"
              ><span>Add to existing suppression list:</span></mat-radio-button>
						</div>
						<div class="w-full md:flex-none md:w-full mb-4 px-2" *ngIf="selectedType === 'suppressionList'">
							<app-select-load-more
								label="Select from list"
								placeholder="Select suppression list"
								labelKey="name"
								valueKey="id"
								[store]="suppressionListStore"
								[showClear]="false"
								(valueChangeEvent)="onSuppressionListChanged($event)"
							></app-select-load-more>
						</div>
					</div>

					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full mb-4 px-2">
							<mat-radio-button
									value="newSuppressionList"
									name="addToListSelectedType"
									ngDefaultControl
									[(ngModel)]="selectedType"
              ><span>Create new suppression list:</span></mat-radio-button>
						</div>
						<div class="w-full md:flex-none md:w-full px-2" *ngIf="selectedType === 'newSuppressionList'">
							<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="mb-2 w-full">
								<mat-label>Name</mat-label>
								<input matInput type="text" placeholder="Enter name" [(ngModel)]="newSuppressionListName"
									   autocomplete="off" maxlength="250" />
							</mat-form-field>
						</div>
					</div>
				</ng-container>

				<div class="flex flex-wrap -mx-2" *ngIf="(accountAttributesEnum.AUTOREVEAL | hasAccess) && selectedType === 'newSuppressionList'">
					<div class="w-full md:flex-none md:w-full px-2">
						<mat-form-field appearance="outline" [subscriptSizing]="'fixed'" class="mb-2 w-full">
							<mat-label>Availability</mat-label>
							<mat-select [(ngModel)]="isPublicSuppressionList" placeholder="Select availability" #siSelectRef3="matSelect">
								<mat-option [value]="false">Private</mat-option>
								<mat-option [value]="true">Team</mat-option>
							</mat-select>
							<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef3.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
						</mat-form-field>
					</div>
                    <div class="w-full md:flex-none md:w-full px-2">
                        <app-multi-selector-form-field
                            [showChipsList]="true"
                            [items]="tagList$ | async"
                            bindLabel="name"
                            bindValue="id"
                            label="Tags"
                            placeholder="Tags"
                            [(ngModel)]="tagsSuppressionList"
                            name="tagsSuppressionList"
                            [isLoading]="(isCreateTagLoading$ | async)"
                            ngDefaultControl
                            [listElementTooltipIfTruncated]="true"
                        >
                            <ng-template #preOption let-value="inputValue">
                                <span><a class="cp-dark-link" (click)="createTag(value)">{{value}} (Create New)</a></span>
                            </ng-template>
                        </app-multi-selector-form-field>
                    </div>
				</div>
			</mat-radio-group>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<button matButton="outlined" type="button" (click)="onClose()">Cancel</button>
		<button matButton="filled" type="button"
				[disabled]="isLoading || !(contactListId || newContactListName.trim() || companyListId || newCompanyListName.trim() || suppressionListId || newSuppressionListName.trim())"
				(click)="onSaveList()">Save</button>
	</ng-template>
</app-si-dialog>
